// MIDI protocol for the prototype room controller.
//
// Selector notes (status 0x90/0x80):
//   0x08–0x0D -> speakers 1–6
//   0x10–0x15 -> screens 1–6
//   0x17      -> tray
//
// Macro pads (status 0x99 press / 0x89 release) span 0x24–0x33 in two rows:
//   [0x2C–0x33] -> slots 1–8, [0x24–0x2B] -> slots 9–16
//
// Control changes (status 0xB0):
//   0x32 -> record (held), 0x33 -> cancel recording

const NOTE_ON = 0x90
const NOTE_OFF = 0x80
const MACRO_NOTE_ON = 0x99
const MACRO_NOTE_OFF = 0x89
const CONTROL_CHANGE = 0xb0

const SPEAKER_NOTE_START = 0x08
const SPEAKER_COUNT = 6
const SCREEN_NOTE_START = 0x10
const SCREEN_COUNT = 6
const TRAY_NOTE = 0x17

const MACRO_NOTE_MIN = 0x24
const MACRO_NOTE_MAX = 0x33

const RECORD_CC = 0x32
const CANCEL_CC = 0x33

const VELOCITY_ON = 0x7f
const VELOCITY_OFF = 0x00

// selectors are string keys: 'speaker-1'…'speaker-6', 'screen-1'…'screen-6', 'tray'
type SelectorKey = string

const noteToSelector = (note: number): SelectorKey | undefined => {
  if (note >= SPEAKER_NOTE_START && note < SPEAKER_NOTE_START + SPEAKER_COUNT)
    return `speaker-${note - SPEAKER_NOTE_START + 1}`
  if (note >= SCREEN_NOTE_START && note < SCREEN_NOTE_START + SCREEN_COUNT)
    return `screen-${note - SCREEN_NOTE_START + 1}`
  if (note === TRAY_NOTE) return 'tray'
  return undefined
}

const selectorToNote = (selector: SelectorKey): number | undefined => {
  if (selector === 'tray') return TRAY_NOTE
  const [kind, idxStr] = selector.split('-')
  const idx = Number(idxStr) - 1
  if (kind === 'speaker' && idx >= 0 && idx < SPEAKER_COUNT)
    return SPEAKER_NOTE_START + idx
  if (kind === 'screen' && idx >= 0 && idx < SCREEN_COUNT)
    return SCREEN_NOTE_START + idx
  return undefined
}

// Macro pads: [2C–33] map to slots 0–7, [24–2B] map to slots 8–15
const noteToMacroSlot = (note: number): number | undefined => {
  if (note < MACRO_NOTE_MIN || note > MACRO_NOTE_MAX) return undefined
  return note >= 0x2c ? note - 0x2c : note - 0x24 + 8
}

export {
  NOTE_ON,
  NOTE_OFF,
  MACRO_NOTE_ON,
  MACRO_NOTE_OFF,
  CONTROL_CHANGE,
  RECORD_CC,
  CANCEL_CC,
  VELOCITY_ON,
  VELOCITY_OFF,
  noteToSelector,
  selectorToNote,
  noteToMacroSlot,
  type SelectorKey,
}
